export const VALID_TAG_COLORS = ['blue', 'green', 'teal', 'yellow', 'red', 'purple', 'gray'] as const;
export const FOLLOW_UP_SMART_TAG_ID = 'd11b6316-e9f8-57a1-bc43-a7f82762e185';
export const PRESCRIPTION_REFILL_SMART_TAG_ID = '806f0dbc-1222-54f4-9f95-0d23cda7f841';
export const OUTSTANDING_BALANCE_SMART_TAG_ID = '30033e3f-378a-568f-95de-df54fde6a0fb';
